export const locationsUrls = [
  "/states",
  "/countries",
  "/cities",
  "/naics-code",
];

export const throwPostResponseUrls = ["/withdrawal/accept", "/exchange/accept"];
export const throwGetResponseUrls = ["/bridge/activate", "/bridge/customer"];

export const ignoreErrorPostUrls = ["/accounts", "/withdrawal/accept"];
export const ignoreErrorGetUrls = [];
